/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamTriggerEmergencyStopMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamTriggerEmergencyStopMutation = {
  __typename?: 'Mutation'
  fccTriggerEmergencyStop: any | null
}

export type AdVehicleStreamEmergencyStopAlertsQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type AdVehicleStreamEmergencyStopAlertsQuery = {
  __typename?: 'Query'
  vehicleByID: {
    __typename?: 'Vehicle'
    id: string
    fccCurrentAdAlerts: {
      __typename?: 'FccAdAlerts'
      alerts: Array<{ __typename?: 'FccAdAlert'; type: Types.FccAdAlertType }>
    } | null
  }
}

export const AdVehicleStreamTriggerEmergencyStopDocument = gql`
    mutation AdVehicleStreamTriggerEmergencyStop($vehicleId: ID!) {
  fccTriggerEmergencyStop(input: {vehicleId: $vehicleId})
}
    `
export type AdVehicleStreamTriggerEmergencyStopMutationFn =
  Apollo.MutationFunction<
    AdVehicleStreamTriggerEmergencyStopMutation,
    AdVehicleStreamTriggerEmergencyStopMutationVariables
  >

/**
 * __useAdVehicleStreamTriggerEmergencyStopMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamTriggerEmergencyStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamTriggerEmergencyStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamTriggerEmergencyStopMutation, { data, loading, error }] = useAdVehicleStreamTriggerEmergencyStopMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamTriggerEmergencyStopMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamTriggerEmergencyStopMutation,
    AdVehicleStreamTriggerEmergencyStopMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamTriggerEmergencyStopMutation,
    AdVehicleStreamTriggerEmergencyStopMutationVariables
  >(AdVehicleStreamTriggerEmergencyStopDocument, options)
}
export type AdVehicleStreamTriggerEmergencyStopMutationHookResult = ReturnType<
  typeof useAdVehicleStreamTriggerEmergencyStopMutation
>
export type AdVehicleStreamTriggerEmergencyStopMutationResult =
  Apollo.MutationResult<AdVehicleStreamTriggerEmergencyStopMutation>
export type AdVehicleStreamTriggerEmergencyStopMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamTriggerEmergencyStopMutation,
    AdVehicleStreamTriggerEmergencyStopMutationVariables
  >
export const AdVehicleStreamEmergencyStopAlertsDocument = gql`
    query AdVehicleStreamEmergencyStopAlerts($vehicleId: ID!) {
  vehicleByID(id: $vehicleId) {
    id
    fccCurrentAdAlerts {
      alerts {
        type
      }
    }
  }
}
    `

/**
 * __useAdVehicleStreamEmergencyStopAlertsQuery__
 *
 * To run a query within a React component, call `useAdVehicleStreamEmergencyStopAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamEmergencyStopAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamEmergencyStopAlertsQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamEmergencyStopAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdVehicleStreamEmergencyStopAlertsQuery,
    AdVehicleStreamEmergencyStopAlertsQueryVariables
  > &
    (
      | {
          variables: AdVehicleStreamEmergencyStopAlertsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdVehicleStreamEmergencyStopAlertsQuery,
    AdVehicleStreamEmergencyStopAlertsQueryVariables
  >(AdVehicleStreamEmergencyStopAlertsDocument, options)
}
export function useAdVehicleStreamEmergencyStopAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdVehicleStreamEmergencyStopAlertsQuery,
    AdVehicleStreamEmergencyStopAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdVehicleStreamEmergencyStopAlertsQuery,
    AdVehicleStreamEmergencyStopAlertsQueryVariables
  >(AdVehicleStreamEmergencyStopAlertsDocument, options)
}
// @ts-ignore
export function useAdVehicleStreamEmergencyStopAlertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdVehicleStreamEmergencyStopAlertsQuery,
    AdVehicleStreamEmergencyStopAlertsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamEmergencyStopAlertsQuery,
  AdVehicleStreamEmergencyStopAlertsQueryVariables
>
export function useAdVehicleStreamEmergencyStopAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamEmergencyStopAlertsQuery,
        AdVehicleStreamEmergencyStopAlertsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdVehicleStreamEmergencyStopAlertsQuery | undefined,
  AdVehicleStreamEmergencyStopAlertsQueryVariables
>
export function useAdVehicleStreamEmergencyStopAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdVehicleStreamEmergencyStopAlertsQuery,
        AdVehicleStreamEmergencyStopAlertsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdVehicleStreamEmergencyStopAlertsQuery,
    AdVehicleStreamEmergencyStopAlertsQueryVariables
  >(AdVehicleStreamEmergencyStopAlertsDocument, options)
}
export type AdVehicleStreamEmergencyStopAlertsQueryHookResult = ReturnType<
  typeof useAdVehicleStreamEmergencyStopAlertsQuery
>
export type AdVehicleStreamEmergencyStopAlertsLazyQueryHookResult = ReturnType<
  typeof useAdVehicleStreamEmergencyStopAlertsLazyQuery
>
export type AdVehicleStreamEmergencyStopAlertsSuspenseQueryHookResult =
  ReturnType<typeof useAdVehicleStreamEmergencyStopAlertsSuspenseQuery>
export type AdVehicleStreamEmergencyStopAlertsQueryResult = Apollo.QueryResult<
  AdVehicleStreamEmergencyStopAlertsQuery,
  AdVehicleStreamEmergencyStopAlertsQueryVariables
>
